import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useTranslations } from '../i18n/translations';
import { clientLogos } from '../data/clientLogos';
interface ClientLogosStripProps {
  theme?: 'light' | 'dark';
}
export function ClientLogosStrip({
  theme = 'light'
}: ClientLogosStripProps) {
  const {
    lang
  } = useLanguage();
  const t = useTranslations(lang);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const isDark = theme === 'dark';
  return <section className={`relative py-10 lg:py-12 border-y ${isDark ? 'bg-white/[0.03] border-white/10' : 'bg-white border-navy-100'}`} aria-label={t.clients.title} data-id="element-130" data-mp="mdgtz60bz77r">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-131" data-mp="1xs3t0sbgzp9f">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} className={`text-center text-xs font-semibold tracking-widest uppercase mb-7 ${isDark ? 'text-white/50' : 'text-navy-400'}`} data-id="element-132" data-mp="22rgo20chw2n3">
          {t.clients.eyebrow}
        </motion.p>

        <motion.ul initial={{
        opacity: 0,
        y: 12
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-8 gap-3 sm:gap-4" data-id="element-133" data-mp="r4bemzj31m8m">
          {clientLogos.map(logo => <li key={logo.name} className={`aspect-[3/2] rounded-lg border flex items-center justify-center p-3 ${isDark ? 'border-white/10' : 'border-navy-100'} ${logo.bgClass}`} title={logo.name} data-id="element-134" data-mp="cgqbj5m7jn0p">
              <img src={logo.logo} alt={logo.name} className="w-full h-full object-contain" loading="lazy" data-id="element-135" data-mp="3umlgidct0ix7" />
            </li>)}
        </motion.ul>
      </div>
    </section>;
}